export const initializeRefValue = <T extends HTMLInputElement>(
  ref: React.RefObject<T>,
  initializationTargetValue: unknown = '',
) => {
  if (ref.current) {
    ref.current.value = String(initializationTargetValue);
  }
};
